bridge_soilstructure
<template>
    <el-row class="content_wrap">
        <el-row>
            <el-col :span="24"><div class="grid-content bg-purple-dark u_qiaosui_header"><i class="el-icon-s-finance"></i>土建结构异常</div></el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <div class="grid-content bg-purple-dark u_suidao_title_c">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <div class="grid-content bg-purple u_suidao_bg1" style="padding: 10px;">
                                开发中...
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
        </el-row>
    </el-row>
</template>

<script>
import $ from 'jquery'
export default {
    name: 'bridgeSoilstructure',
    data() {
        return {
        }
    },
    components: {
    },
    created() {
    },
    mounted: function () {
    },
    methods: {
        
    },
}
</script>
